


















import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class AuthPanel extends Vue {
  show = false;

  @Prop({ type: String, default: "" }) readonly name!: string;
  @Prop({ type: Function, default: () => null }) readonly logout!: () => void;
}
